import { Popover } from 'antd'
import React, { PureComponent } from 'react'

export default class EKBPopover extends PureComponent {
  render() {
    return <Popover {...this.props}>{this.props.children}</Popover>
  }
}
